// routes
import { PATH_LMS } from '../../../routes/paths';
// components
import { RoleType } from '../../../@types/lms/enums';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
};

const navConfig = [
  //LMS
  {
    subheader: 'Label Validation System',
    items: [
      {
        title: 'Home',
        path: PATH_LMS.home,
        icon: ICONS.dashboard,
        roles: [
          RoleType.Admin,
          RoleType.CompanyUser,
          RoleType.Coordinator
        ],
      },
      {
        title: 'Assignments',
        path: PATH_LMS.inspections.list,
        icon: ICONS.booking,
        roles: [
          RoleType.Admin,
          RoleType.CompanyUser,
          RoleType.MultiVendorCustomer,
          RoleType.Reviewer,
          RoleType.Coordinator,
          RoleType.LocalAffiliateCoordinator,
          RoleType.LimitedAccessCoordinator,
        ],
        // children: [
        //   { title: 'list', path: PATH_LMS.inspections.list, roles: [RoleType.Admin,RoleType.CompanyUser,RoleType.MultiVendorCustomer,RoleType.Reviewer,RoleType.Coordinator,RoleType.LocalAffiliateCoordinator,RoleType.LimitedAccessCoordinator] },
        //   { title: 'create', path:PATH_LMS.inspections.new, roles: [RoleType.Admin,RoleType.CompanyUser] },
        // ]
      },
      {
        title: 'blog',
        path: PATH_LMS.blog.list,
        icon: ICONS.blog,
        roles: [
          RoleType.Admin,
          RoleType.CompanyUser,
          RoleType.MultiVendorCustomer,
          RoleType.Reviewer,
          RoleType.Coordinator,
          RoleType.LocalAffiliateCoordinator,
          RoleType.LimitedAccessCoordinator,
        ],
      },
      {
        title: 'Admin',
        path: PATH_LMS.admin,
        icon: ICONS.menuItem,
        roles: ['Admin'],
        children: [
        {
          title: 'users',
          path: PATH_LMS.user.list,
          icon: ICONS.menuItem,
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.user.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.user.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'resources',
          path: PATH_LMS.country.list,
          icon: ICONS.menuItem,
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.country.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.country.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'clients',
          path: PATH_LMS.company.list,
          icon: ICONS.menuItem,
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.company.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.company.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'working days',
          path: PATH_LMS.workingdays.list,
          icon: ICONS.menuItem,
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.workingdays.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.workingdays.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'Assignment Types',
          path: '#',
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.reviewtypes.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.reviewtypes.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'Assignment Questions',
          path: '#',
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.questions.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.questions.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'Client Help Text',
          path: '#',
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.helptextclient.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.helptextclient.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'Reviewer Help Text',
          path: '#',
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.helptextreviewer.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.helptextreviewer.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'organizations',
          path: PATH_LMS.affiliate.list,
          icon: ICONS.menuItem,
          roles: ['Admin'],
          children: [
            { title: 'list', path: PATH_LMS.affiliate.list, roles: ['Admin'] },
            { title: 'create', path: PATH_LMS.affiliate.new, roles: ['Admin'] },
          ],
        },
        {
          title: 'PDF Editor',
          path: PATH_LMS.pdf.list,
          icon: ICONS.invoice,
          roles: ['Admin'],
          // children: [
          //   { title: 'list', path: PATH_LMS.pdf.list, roles: ['Admin'] },
          // ]
        }]
      }
        // {
        //   title: 'mail',
        //   path: PATH_LMS.mail.root,
        //   icon: ICONS.mail,
        //   roles: ['Admin'],
        // },
        // {
        //   title: 'documents',
        //   path: PATH_LMS.documents.all,
        //   icon: ICONS.invoice,
        //   roles: ['Admin'],
        // },
      ],
    },
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     { title: 'app', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
  //     { title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
  //     { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
  //     { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
  //     { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
  //   ],
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     // USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.new },
  //         { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
  //         { title: 'account', path: PATH_DASHBOARD.user.account },
  //       ],
  //     },

  //     // E-COMMERCE
  //     {
  //       title: 'ecommerce',
  //       path: PATH_DASHBOARD.eCommerce.root,
  //       icon: ICONS.cart,
  //       children: [
  //         { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //         { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
  //         { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //         { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
  //         { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
  //         { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //       ],
  //     },

  //     // INVOICE
  //     {
  //       title: 'invoice',
  //       path: PATH_DASHBOARD.invoice.root,
  //       icon: ICONS.invoice,
  //       children: [
  //         { title: 'list', path: PATH_DASHBOARD.invoice.list },
  //         { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.invoice.new },
  //         { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
  //       ],
  //     },

  //     // BLOG
  //     {
  //       title: 'blog',
  //       path: PATH_DASHBOARD.blog.root,
  //       icon: ICONS.blog,
  //       children: [
  //         { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //         { title: 'post', path: PATH_DASHBOARD.blog.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.blog.new },
  //       ],
  //     },
  //   ],
  // },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: <Label color="error">+32</Label>,
  //     },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban },
  //   ],
  // },

  // DEMO MENU STATES
  // {
  //   subheader: 'Other cases',
  //   items: [
  //     {
  //       // default roles : All roles can see this entry.
  //       // roles: ['user'] Only users can see this item.
  //       // roles: ['admin'] Only admin can see this item.
  //       // roles: ['admin', 'manager'] Only admin/manager can see this item.
  //       // Reference from 'src/guards/RoleBasedGuard'.
  //       title: 'item_by_roles',
  //       path: PATH_DASHBOARD.permissionDenied,
  //       icon: ICONS.menuItem,
  //       roles: ['admin'],
  //       caption: 'only_admin_can_see_this_item',
  //     },
  //     {
  //       title: 'menu_level_1',
  //       path: '#1',
  //       icon: ICONS.menuItem,
  //       children: [
  //         { title: 'menu_level_2', path: '#2', disabled: true },
  //         {
  //           title: 'menu_level_2',
  //           path: '#3',
  //           children: [
  //             { title: 'menu_level_3', path: '#4' },
  //             { title: 'menu_level_3', path: '#5' },
  //           ],
  //         },
  //       ],
  //     },
  //     { title: 'item_disabled', path: '#disabled', icon: ICONS.menuItem, disabled: true },
  //     {
  //       title: 'item_label',
  //       path: '#label',
  //       icon: ICONS.menuItem,
  //       info: (
  //         <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
  //           NEW
  //         </Label>
  //       ),
  //     },
  //     { title: 'item_caption', path: '#caption', icon: ICONS.menuItem, caption: 'description' },
  //   ],
  // },
];

export default navConfig;
